module.exports = __webpack_public_path__ + "static/media/42-7.759849df.mp3";